import React from 'react'
import { useForm } from 'react-hook-form'
import { TextField } from '@mui/material'
import { Button } from '@mui/material'
import { useGetEvents } from 'hooks/useGetEvents'
import { Event } from 'interfaces/entities/event.model'
import { EventItem } from './EventItem'
import eventsService from 'services/admin/eventsService'
import { toast } from 'react-toastify'
import { queryClient } from 'queryClient'


interface LeadEventsProps {
    leadID: string
}
export const LeadEvents = ({ leadID }: LeadEventsProps) => {
    const { data: events } = useGetEvents(leadID)
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            text: '',
        },
        mode: 'onChange'
    })

    const onSubmit = async (data: any) => {
        console.log(data)
        try {
            if (!data.text) {
                toast.error('Комментарий не может быть пустым!')
                return
            }
            if (data.text.length < 3) {
                toast.error('Комментарий должен быть больше 3 символов!')
                return
            }
            const eventInput = {
                leadID,
                eventType: 'COMMENT_ADDED',
                payload: {
                    text: data.text,
                },
            }
            await eventsService.addEvent(eventInput)
            toast.success('Комментарий добавлен успешно!')
            // Заново запросить события
            queryClient.invalidateQueries({ queryKey: ['events', leadID] })

            reset()
        } catch (error) {
            console.error(error)
            toast.error('Ошибка при добавлении комментария!')
        }
    }

    return (
        <div>
            {/* Форма оставление комментария */}
            <div className='flex flex-col gap-2'>
                <TextField multiline rows={4} label="Комментарий" {...register('text')} fullWidth />
                <Button type="button" variant="outlined" color="primary" onClick={handleSubmit(onSubmit)}>
                    Отправить
                </Button>
            </div>
            {/* Список комментариев */}
            <div className='flex flex-col gap-2 mt-8'>
                {events?.map((event: Event) => (
                    <div key={event.id}>
                        <EventItem event={event} />
                    </div>
                ))}
            </div>
        </div>
    )
}
